import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, map, of, switchMap } from 'rxjs'
import { loadStateFailure, loadStates, loadStatesSuccess } from './state.actions'
import { StateService } from '../../services/state.service'

export const loadStates$ = createEffect(
  (actions$ = inject(Actions), stateService = inject(StateService)) =>
    actions$.pipe(
      ofType(loadStates),
      switchMap(action =>
        stateService.getStatesByCountry(action.countryId).pipe(
          map(states => loadStatesSuccess({ states })),
          catchError(error => of(loadStateFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

export const stateEffects = { loadStates$ }
